module.exports = __webpack_public_path__ + "img/4.8d3301a5.png";